import { render, staticRenderFns } from "./DiffUtils.vue?vue&type=template&id=7c267ba8&"
import script from "./DiffUtils.vue?vue&type=script&lang=js&"
export * from "./DiffUtils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports